import cx from "classnames";
import React from "react";

import { ContentType, ImageBlock, MathBlock } from "../../types";

type Props = Readonly<{
  block: ImageBlock | MathBlock;
  gutter: number;
  onSelectBlock: (blockId: string, textContent: string, replace: boolean) => void;
  onShowReferences: (zoneId: string) => void;
  scale: number;
  selected: boolean;
}>;

const ImageZoneComponent = ({
  block,
  gutter,
  onShowReferences,
  onSelectBlock,
  scale,
  selected,
}: Props) => {
  const style = {
    height: block.height * scale,
    left: block.x * scale + gutter,
    top: block.y * scale,
    width: block.width * scale,
  };
  return (
    <div
      className={cx("zone", block.confidenceClass, { selected })}
      id={block.id}
      onClick={e => {
        if (e.shiftKey && block.references.length > 0) {
          e.preventDefault();
          onShowReferences(block.id);
          return;
        }
        e.preventDefault();
        onSelectBlock(block.id, block.text, e.ctrlKey);
      }}
      style={style}
    />
  );
};
ImageZoneComponent.displayName = "ImageZone";
export const ImageZone = React.memo(ImageZoneComponent);
